var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProgressbarCheck = function SvgProgressbarCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M36.563,18.563a18,18,0,1,1-18-18A18,18,0,0,1,36.563,18.563ZM16.48,28.093,29.835,14.739a1.161,1.161,0,0,0,0-1.642l-1.642-1.642a1.161,1.161,0,0,0-1.642,0L15.659,22.345,10.574,17.26a1.161,1.161,0,0,0-1.642,0L7.29,18.9a1.161,1.161,0,0,0,0,1.642l7.548,7.548a1.161,1.161,0,0,0,1.642,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#528a3e",
    opacity: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProgressbarCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progressbar-check.487b99d8ebdb8501c8ab48f6dc7dd96e.svg";